package tta.destinigo.talktoastro.feature_authentication.persentation.otp_validation_page

sealed class OtpValidationState {
    data class OnError(val message: String) : OtpValidationState()
    data class OnLoading(val isLoading: Boolean) : OtpValidationState()
    data class OnOtpSent(val msg: String) : OtpValidationState()
    data class OnOtpValidated(val msg: String) : OtpValidationState()
}
